<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" version="1.1" viewBox="-10 0 350 340">
    <g>
      <path stroke="null" id="svg_1" d="m154.5,173.04268l123.14634,124.95732l25.35366,-25.35366l-124.95732,-123.14634l124.95732,-123.14634l-25.35366,-25.35366l-123.14634,124.95732l-123.14634,-124.95732l-25.35366,25.35366l124.95732,123.14634l-124.95732,123.14634l25.35366,25.35366l123.14634,-124.95732z" fill="currentColor"/>
    </g>
  </svg>
</template>